<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="partText"
    item-value="partCd"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    @change="onChange"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'SupplierPartInput',

  mixins: [APIUtils, Message],
  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    isSearchByLoginCompany: {
      type: Boolean,
      default: false,
      required: false,
    },
    supplierCd: {
      type: String,
      required: true,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0059')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  watch: {
    async supplierCd(value) {
      await this.setSupplierParts(value)
    },
  },

  methods: {
    onChange() {
      this.$emit('change')
    },
    async setSupplierParts(supplierCd) {
      this.loading = true
      this.items = []

      try {
        let params = {}
        if (!supplierCd && !this.isSearchByLoginCompany) {
          return
        }

        // supplierCd/isSearchByLoginCompanyのどちらかのみ指定可能
        if (this.supplierCd) {
          params.supplierCd = supplierCd
        } else if (this.isSearchByLoginCompany) {
          params.userCompanyCd = this.$store.getters.companyCd
        }

        if (this.validOnly) {
          params.validOnly = true
        }

        const elements = await API.get('/master/supplierParts/specifySupplier', params)
        this.items = []
        elements.forEach((element) => {
          element['partText'] = `${element['partCd']} : ${element['partName']}`
          this.items.push(element)
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0059') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.setSupplierParts(this.supplierCd)
  },
}
</script>
